import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { adminUsersApi } from "../api";

const loginAs = async (id) => {
  try {
    await adminUsersApi.loginAs({ id: id.toString() });
    window.location.replace("/");
  } catch (err) {
    console.log(err);
  }
};

export const LoginAs = ({ isOpen, onClose, selected: { id } = {} }) => {
  const primaryBtnHandler = () => {
    loginAs(id);
    onClose();
  };

  return (
    <MainModal
      parentSelector=".admin-users"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Login As User to Test"
      headerCloseHandler={onClose}
      width={500}
      height="auto"
      primaryButtonText="Login As"
      primaryBtnHandler={primaryBtnHandler}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      You will be logged out of current user and logged into selected user to verify the users
      permissions. Proceed?
    </MainModal>
  );
};
